var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (style) {
buf.push("<h1>Настройки</h1><component is=\"alert\" name=\"{{ name }}\" message=\"{{ data.message }}\"></component><form v-on=\"submit: submit\" v-el=\"form\"><label><span>Номер телефона</span><input type=\"tel\" name=\"phone\" v-model=\"form.phone\"></label><label><span>Номер договора</span><input type=\"text\" name=\"agreement_number\" v-model=\"form.agreement_number\"></label><label><span>E-mail для уведомлений о входе в личный кабинет</span><input type=\"email\" name=\"email\" v-model=\"form.email\"></label><label><span>E-mail для аватара с сервиса&nbsp;<a rel=\"noflow\" href=\"https://ru.gravatar.com\">gravatar</a></span><input type=\"email\" name=\"gravator_email\" v-model=\"form.gravator_email\"></label><button type=\"submit\"" + (jade.cls([style.btn], [true])) + ">Сохранить</button></form>");}.call(this,"style" in locals_for_with?locals_for_with.style:typeof style!=="undefined"?style:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/settings/template.jade
 ** module id = 198
 ** module chunks = 0
 **/